import React from 'react';
import styles from './ServerLatencyGraph.module.css';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const ServerLatencyGraph = ({ pingData, statusDetails, avgPing }) => {

    const chartData = {
        labels: pingData.map((_, index) => `Ping ${index + 1}`),
        datasets: [
            {
                label: 'Ping',
                data: pingData,
                borderColor: statusDetails.color,
                backgroundColor: 'rgb(75, 192, 192)',
                fill: false,
                borderWidth: 2,
                tension: 0.2,
                pointRadius: 0,
                pointHoverRadius: 0,
                pointBorderWidth: 0,
                pointBackgroundColor: 'rgba(0, 0, 0, 0)',
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
            },
        },
        scales: {
            x: {
                display: false,
            },
            y: {
                display: false,
            },
        },
    };

    return (
        <div className={styles.latency_graph}>
            <Line data={chartData} options={options} />
            {avgPing && <div className={styles.average_ping}><span>avg: {avgPing}ms</span></div>}
        </div>
    );
};

export default ServerLatencyGraph;
